export const cookies_string = 'HKULEARNING';
export const server_ip=''

//prod: 'http://43.198.18.229
